<template>
  <div>
    <v-card>
      <v-card-title class="headline primary white--text" dark primary-title>
        {{ $t('modal.delete') }}
      </v-card-title>

      <v-card-text>
        <p>{{ $tc('form.deleteAll', 1, { count: 1 }) }}</p>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn @click="$emit('close')">
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn :loading="deleting" color="primary" @click="doRemove">
          {{ $t('button.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  computed: {
    deleting() {
      return this.$parent.deleting;
    },
  },
  methods: {
    doRemove() {
      this.$emit('remove');
      this.$emit('close');
    },
  },
};
</script>
